import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { FiltroContratista } from "../../interfaces/filtro-contratista.interface";
import { FiltroCotizaciones } from "../../interfaces/filtro-cotizaciones.interface";
import { FiltroFactura } from "../../interfaces/filtro-factura.interface";
import { FiltroOOTT } from "../../interfaces/filtro-oott.interface";
import { FiltroOrdenesCompra } from "../../interfaces/filtro-ordenescompra.interface";

@Injectable({
    providedIn: "root",
})
export class FiltrosService {
    public filtrosContratistaLoaded$: Subject<FiltroContratista>;
    public filtrosOOTTLoaded$: Subject<FiltroOOTT>;
    public filtrosOOCCLoaded$: Subject<FiltroOrdenesCompra>;
    public filtrosCotizacionesLoaded$: Subject<FiltroCotizaciones>;
    public filtrosFacturasLoaded$: Subject<FiltroFactura>;

    private filtrosContratista: FiltroContratista;
    //aqui se deben definir los otros filtros y crear su respectiva interface
    private filtrosClientes: any;
    private filtrosOOCC: FiltroOrdenesCompra;
    private filtrosOOTT: FiltroOOTT;
    private filtrosCotizaciones: FiltroCotizaciones;
    private filtrosFacturas: FiltroFactura;

    constructor() {
        this.filtrosContratistaLoaded$ = new Subject();
        this.filtrosOOTTLoaded$ = new Subject();
        this.filtrosOOCCLoaded$ = new Subject();
        this.filtrosCotizacionesLoaded$ = new Subject();
        this.filtrosFacturasLoaded$ = new Subject();
    }

    getFiltro(nombreFiltroPrincipal: string): any {
        //console.log(nombreFiltroPrincipal);
        if (this[nombreFiltroPrincipal] === undefined) {
            if (nombreFiltroPrincipal === "filtrosContratista") {
                this.initFiltrosContratista();
            }
            if (nombreFiltroPrincipal === "filtrosOOCC") {
                this.initFiltrosOOCC();
            }
            if (nombreFiltroPrincipal === "filtrosOOTT") {
                this.initFiltrosOOTT();
            }
            if (nombreFiltroPrincipal === "filtrosFacturas") {
                this.initFiltrosFactura();
            }

            if (nombreFiltroPrincipal === "filtrosCotizaciones") {
                this.initFiltrosCotizaciones();
            }
            if (nombreFiltroPrincipal === "filtrosClientes") {
                this.initFiltrosCliente();
            }
            return this[nombreFiltroPrincipal];
        }

        return this[nombreFiltroPrincipal];
    }

    initFiltrosContratista(): any {
        this.filtrosContratista = {
            comuna: [{ valor: 0, descripcion: "*", tipo: "number" }],
            grupo: [{ valor: 0, descripcion: "*", tipo: "number" }],
            evaluacion: [{ valor: 0, descripcion: "*", tipo: "number" }],
            estado: [{ valor: true, descripcion: "*", tipo: "boolean" }],
            nombre: [{ valor: "", descripcion: "*", tipo: "string" }],
            rut: [{ valor: 0, descripcion: "*", tipo: "number" }],
        };
        this.filtrosContratistaLoaded$.next(this.filtrosContratista);
    }

    initFiltrosOOCC(): any {
        this.filtrosOOCC = {
            estado: [{ valor: 0, descripcion: "Todos", tipo: "number" }],
            cliente: [{ valor: "", descripcion: "Todos", tipo: "text" }],
            rut: [{ valor: "", descripcion: "Todos", tipo: "number" }],
            nroOOCC: [{ valor: "", descripcion: "Todos", tipo: "text" }],
            recepcion: [{ valor: 0, descripcion: "Todos", tipo: "text" }]
        };
        this.filtrosOOCCLoaded$.next(this.filtrosOOCC);
    }

    initFiltrosFactura(): any {
        this.filtrosFacturas = {
            estado: [{ valor: 0, descripcion: "Todos", tipo: "number" }],
            cliente: [{ valor: "", descripcion: "Todos", tipo: "string" }],
            nombre: [{ valor: "", descripcion: "Todos", tipo: "string" }],
            rut: [{ valor: "", descripcion: "Todos", tipo: "string" }],
            nroFactura: [{ valor: "", descripcion: "Todos", tipo: "number" }],
        };
        this.filtrosFacturasLoaded$.next(this.filtrosFacturas);
    }


    initFiltrosCliente(): any {
        this.filtrosClientes = {
            estado: [{ valor: 0, descripcion: "Todos", tipo: "number" }],
            cliente: [{ valor: "", descripcion: "Todos", tipo: "string" }],
        };
        this.filtrosFacturasLoaded$.next(this.filtrosFacturas);
    }

    initFiltrosOOTT(): void {
        //console.log("entroooo a carar filtros");
        /*
        this.filtrosOOTT = {
            nroOOTT: [{ valor: 0, descripcion: "Todos", tipo: "number" }],
            nroTicket: [{ valor: 0, descripcion: "Todos", tipo: "text" }],
            idCliente: [{ valor: 0, descripcion: "Todos", tipo: "number" }],
            nombreContratista: [{ valor: 0, descripcion: "Todos", tipo: "text" }],
            rutContratista: [{ valor: 0, descripcion: "Todos", tipo: "number" }],
            estadoOOTT: [{ valor: 0, descripcion: "Todos", tipo: "number" }],
            situacion: [{ valor: 0, descripcion: "Todos", tipo: "number" }],
        };
        */

        this.filtrosOOTT = {
            nroTicket: [{ valor: 0, descripcion: "Todos", tipo: "text" }],
            idCliente: [{ valor: 0, descripcion: "Todos", tipo: "number" }],
            estadoOOTT: [{ valor: 0, descripcion: "Todos", tipo: "number" }],
            situacion: [{ valor: 0, descripcion: "Todos", tipo: "number" }],
            estadoPago: [{ valor: 0, descripcion: "Todos", tipo: "number" }]
        };
        this.filtrosOOTTLoaded$.next(this.filtrosOOTT);
    }

    initFiltrosCotizaciones(): void {
        this.filtrosCotizaciones = {
            vigencia: [{ valor: 0, descripcion: "Todos", tipo: "number" }],
            situacion: [{ valor: 0, descripcion: "Todos", tipo: "number" }],
            idCliente: [{ valor: 0, descripcion: "Todos", tipo: "number" }],
        };

        this.filtrosCotizacionesLoaded$.next(this.filtrosCotizaciones);
    }

    //initFiltrosClientes(): void {
    //    this.filtrosClientes = {};
    //}

    setFiltro(
        nombreFiltroPrincipal: string,
        nombreFiltro: string,
        valor: string | number | boolean,
        descripcion: string
    ) {
        const aux = { ...this[nombreFiltroPrincipal][nombreFiltro][0] };

        this[nombreFiltroPrincipal][nombreFiltro] = [];
        this[nombreFiltroPrincipal][nombreFiltro].push({
            valor,
            descripcion,
            tipo: aux.tipo,
        });
    }

    resetFiltro(nombreFiltroPrincipal: string, nombreFiltro: string) {
        const aux = { ...this[nombreFiltroPrincipal][nombreFiltro][0] };
        //console.log(this[nombreFiltroPrincipal][nombreFiltro][0]);

        let valor: string | number | boolean;
        if (this[nombreFiltroPrincipal][nombreFiltro][0].tipo === "string") {
            valor = "";
        } else if (
            this[nombreFiltroPrincipal][nombreFiltro][0].tipo === "number"
        ) {
            valor = 0;
        } else if (
            this[nombreFiltroPrincipal][nombreFiltro][0].tipo === "boolean"
        ) {
            valor = false;
        }

        if (
            nombreFiltroPrincipal === "filtrosClientes" ||
            nombreFiltroPrincipal === "filtrosOOCC" ||
            nombreFiltroPrincipal === "filtrosFacturas" ||
            nombreFiltroPrincipal === "filtrosOOTT" ||
            nombreFiltroPrincipal === "filtrosCotizaciones"
        ) {
            this[nombreFiltroPrincipal][nombreFiltro] = [];
            this[nombreFiltroPrincipal][nombreFiltro].push({
                valor,
                descripcion: "Todos",
                tipo: aux.tipo,
            });
        } else {
            this[nombreFiltroPrincipal][nombreFiltro] = [];
            this[nombreFiltroPrincipal][nombreFiltro].push({
                valor,
                descripcion: "*",
                tipo: aux.tipo,
            });
        }
    }
}
